const objectHelper = {
  filterObject: (obj, callback = (val, key) => Array.isArray(val) ? val.length : val ) => {
    return Object.fromEntries(Object.entries(obj).
      filter(([key, val]) => callback(val, key)));
  }
}
export default objectHelper;
